import { Shimmer } from '@wartek-id/shimmer'
import { Text } from '@wartek-id/text-v1'

interface PanelInfoProps {
  isLoading: boolean
  label?: string
  value?: string
}

export function PanelInfo({ isLoading, label, value }: PanelInfoProps) {
  return (
    <div
      className="uppercase flex space-x-2 bg-white p-4 rounded items-center max-w-md overflow-wrap-anywhere print:p-0"
      aria-live="off"
      aria-busy={isLoading}
    >
      {label && (
        <Text variant="subheading" color="subdued" className="flex-shrink-0">
          {label}
        </Text>
      )}
      {isLoading ? (
        <Shimmer height={22} width={120} />
      ) : (
        <Text variant="heading-sm" className="!text-blue-60">
          {value || '-'}
        </Text>
      )}
    </div>
  )
}

export default PanelInfo
